import Repository from "./repository"

export default {
    post(params) {
        return Repository.post("/api/t201-tmp-order/add", params)
    },
    get(params) {
        let query = '';
        if (params) {
            // パラメータにトークンを追加
            query = '?token=' + params
        }
        return Repository.get("/api/t201-tmp-order/get/" + query)
    }
}